import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import UserCard from "./UserCard";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import CustomSelectMulti from "../../../../../../Components/CustomSelectMulti";
import CustomInput from "../../../../../../Components/CustomInput";
import DataService from "../../../../../../Service";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import SunEditor, { plugins } from "suneditor-react";
import FormControl from "@material-ui/core/FormControl";
import { useLocation } from "react-router-dom";
import Loader from "../../../../../../Components/Loader";

const useStyles = makeStyles((theme) => ({
  in_active: {
    backgroundColor: "#CECFD0",
    color: "#707070",
  },
}));

function ShortList(props) {
  const classes = useStyles();
  const [partnerRolesArr, setPartnerRolesArr] = useState([]);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [userData, setUserData] = useState({ cc: "", to: "" });
  const [checked, setChecked] = useState([]);
  const [checkedAllState, setCheckedAllState] = useState();
  const [checkedLength, setCheckedLength] = useState([]);
  const [pageData, setPageData] = useState([]);
  var localArr = [];

  const dispatch = useDispatch();
  const location = useLocation();

  const setInputState = (inputStateValue, inputId) => {
    // setUserData({ ...userData, [inputId]: inputStateValue })
  };

  useEffect(() => {
    getCoachList();
  }, []);

  const getCoachList = () => {
    DataService.getDirectData("shortlisting_coaches/fetch_shortlist_coaches", {
      assignment_id: props.location.state.currentAssignment.id,
    }).then((res) => {
      pageData.length = 0;
      setPageData(pageData.concat(res.shortlist_coaches));
    });
  };

  const moveToChemistry = (params) => {
    var localArr = [];
    for (const key in checked) {
      if (checked[key]) {
        localArr.push({ coach_id: key });
      }
    }
    const pdata = {
      assignment_id: props.location.state.currentAssignment.id,
      chemistry_coaches: localArr,
    };
    DataService.createData(pdata, "move_to_chemistry")
      .then((res) => {
        dispatch(
          showSnackbar("Success", ["Coach moved to Chemistry successfully"])
        );
        props.setValue(props.value + 1);
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.message]]));
      });
  };

  const getArrLengthForClasses = (obj) => {
    for (const key in obj) {
      localArr.push(obj[key]);
    }
    var activeArr = localArr.filter((option) => option == true);
    checkedLength.length = 0;
    setCheckedLength(checkedLength.concat(activeArr));
  };

  const checkHandler = (e) => {
    console.log(e.target.value, typeof e.target.value, pageData);
    let checkedValue = {};
    if (e.target.value === "checkedAll") {
      pageData?.map(
        (data) =>
          (checkedValue[data.coach_id] =
            data.shortlist_type === "shortlist" ? e.target.checked : undefined)
      );
      console.log("checkedAll", checkedValue);
      setCheckedAllState(e.target.checked);
    } else {
      checkedValue = { ...checked, [e.target.value]: e.target.checked };
    }
    setChecked({ ...checked, ...checkedValue });
    getArrLengthForClasses(checkedValue);
  };

  //  Email Modal

  const [textEditorValue, setTextEditorValue] = useState(undefined);
  const [emailAddress, setEmailAddress] = useState([]);
  const [inputValue, setInputValue] = useState({});
  // const [textEditorValue, setTextEditorValue] = useState(undefined);
  const [sendToArray, setSendToArray] = useState([]);
  const [ccToArray, setCCToArray] = useState([]);
  const [open, setOpen] = useState({
    openDialog: false,
    mailType: "firstMail",
  });

  const handleChangeTextEditorData = (content) => {
    setTextEditorValue(content);
  };

  useEffect(() => {
    if (open.openDialog) {
      fetchEmailAddresses();
      fetchEmailContent();
      fetchExistingEmailAddress();
    }
  }, [open.openDialog]);

  const handleClickOpen = (mailType) => {
    setOpen({ openDialog: true, mailType: mailType });
  };

  const handleClose = () => {
    setOpen((prev) => {
      return { openDialog: false, mailType: prev.mailType };
    });
  };

  const onChangeMultiItem = (obj, inputId, routeFrom) => {
    console.log(obj, "obj");
    if (inputId == "sendToField") {
      setSendToArray(obj);
    }
    if (inputId == "ccToField") {
      setCCToArray(obj);
    }
  };

  const fetchEmailAddresses = () => {
    DataService.getData(
      { assignment_id: location?.state?.currentAssignment?.id },
      "listStakeholdersEmail"
    )
      .then((res) => {
        if (res?.success) {
          res?.email_address?.map((data) => {
            return (data["value"] = data?.email);
          });
          setEmailAddress(res?.["email_address"]);
        }
      })
      .catch((error) => {
        console.log("error =>", error);
      });
  };
  const [loading, setLoading] = useState(false);
  const fetchEmailContent = () => {
    setLoading(true);
    let param = {
      assignment_id: location?.state?.currentAssignment?.id,
      content_type: "",
    };
    const userIds = pageData.filter(
      (el) => el.include_shortlist_email === true
    );
    if (userIds.length > 0) {
      param.user_ids = userIds.map((el) => el.coach_id).join(",") || undefined;
    } else {
      setLoading(false);
      setOpen((prev) => {
        return { ...prev, openDialog: false };
      });
      dispatch(
        showSnackbar("error", [
          "Please include a coach,cannot perform action without coaches",
        ])
      );

      return;
    }
    if (open.mailType === "firstMail") {
      param["content_type"] = "stakeholders email";
    }
    if (open.mailType === "reminder") {
      param["content_type"] = "selected coaches reminder";
    }
    console.log(pageData, "pageData");
    DataService.getData(param, "get_email_content")
      .then((res) => {
        console.log(res, "res");
        if (res?.success) {
          setInputValue({ subject: res?.subject });
          setTextEditorValue(res?.content || "");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error =>", error);
        setLoading(false);
      });
  };
  const fetchExistingEmailAddress = () => {
    DataService.getData(
      {
        assignment_id: location?.state?.currentAssignment?.id,
      },
      "shortListExistingEmail"
    )
      .then((res) => {
        if (res?.success) {
          const ccMail = res?.data?.cc_email_address.map((el) => {
            return { email: el, value: el, label: el };
          });
          const sendTo = res?.data?.to_email_address.map((el) => {
            return { email: el, value: el, label: el };
          });
          setCCToArray(ccMail);
          setSendToArray(sendTo);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const sendMail = (e) => {
    e.preventDefault();
    // setIsSubmit(true);
    if (sendToArray?.length) {
      // setLoading(true);
      let param = {
        assignment_id: location?.state?.currentAssignment?.id,
        to_email_address: sendToArray?.length
          ? sendToArray.map((item) => item.email)
          : [],
        cc_email_address: ccToArray?.length
          ? ccToArray.map((item) => item.email)
          : [],
        subject: inputValue?.subject,
        content: textEditorValue,
      };
      if (open.mailType === "firstMail") {
        param["content_type"] = "stakeholders email";
      }
      if (open.mailType === "reminder") {
        param["content_type"] = "selected coaches reminder";
      }
      DataService.createData(param, "coachesSendEmail")
        .then((res) => {
          if (res?.success) {
            dispatch(showSnackbar("success", [res?.message]));
            handleClose();
          }
          // setLoading(false)
        })
        .catch((error) => {
          console.log("error =>", error);
          dispatch(showSnackbar("success", [error?.message ?? ""]));
          handleClose();
          // setLoading(false)
        });
    }
  };

  return (
    <Box>
      <Grid container direction="row" spacing={2} alignItems="center">
        {pageData.length > 0 && (
          <>
            <Grid
              item
              xs={1}
              style={{
                justifyContent: "center",
                flexBasis: "0",
              }}
            >
              <Checkbox
                onChange={checkHandler}
                value="checkedAll"
                checked={checkedAllState}
              />
            </Grid>
            <Grid item xs={5}>
              <Typography variant="h2">Select All</Typography>
            </Grid>
          </>
        )}
        <Grid item xs={pageData.length > 0 ? 6 : 12}>
          <Box fontWeight="fontWeightBold" my={2} textAlign="right">
            <Button
              disableElevation
              disabled={checkedLength.length === 0 ? true : false}
              variant="contained"
              color="secondary"
              onClick={moveToChemistry}
              className={checkedLength.length == 0 ? classes.in_active : {}}
              style={{ marginRight: 10, textTransform: "none" }}
            >
              <PersonOutlineIcon color="#707070" />
              &nbsp;Chemistry
            </Button>
            <Button
              disableElevation
              variant="contained"
              style={{
                textTransform: "none",
                backgroundColor: "#07438f",
                color: "#fff",
                width: "140px",
              }}
              onClick={() => handleClickOpen("firstMail")}
            >
              Client shortlist{" "}
            </Button>
          </Box>
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"flex-end"}
            mb={2}
          >
            <Button
              disableElevation
              variant="contained"
              style={{
                textTransform: "none",
                backgroundColor: "#07438f",
                color: "#fff",
                width: "110px",
              }}
              onClick={() => handleClickOpen("reminder")}
            >
              Reminder{" "}
            </Button>
          </Box>
        </Grid>
      </Grid>
      {pageData.length > 0 &&
        pageData.map((option) => {
          return (
            <Box mb={2}>
              <Grid container direction="row" spacing={2}>
                <Grid
                  item
                  xs={1}
                  style={{
                    justifyContent: "center",
                    flexBasis: "0",
                    margin: "48px 0px",
                  }}
                >
                  <Checkbox
                    onChange={checkHandler}
                    disabled={
                      option?.shortlist_type === "confirmed" ||
                      option?.shortlist_type === "chemistry"
                    }
                    checked={
                      checked[option?.coach_id] === undefined
                        ? false
                        : checked[option?.coach_id]
                    }
                    value={option?.coach_id}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={11}
                  style={{
                    marginLeft: "0px",
                    border: "solid 1px",
                    borderColor: "#CACED5",
                  }}
                >
                  <UserCard
                    moved={
                      option?.shortlist_type === "confirmed" ||
                      option?.shortlist_type === "chemistry"
                    }
                    {...props}
                    buttonText={option?.shortlist_type}
                    pageData={option || {}}
                    content="shortlist"
                    getCoachList={getCoachList}
                  />
                </Grid>
              </Grid>
            </Box>
          );
        })}
      <Box>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open.openDialog}
          fullWidth="100%"
          maxWidth={maxWidth}
          style={{ padding: 24 }}
        >
          <DialogContent>
            <Box p={3}>
              <Grid container direction="row">
                <Grid item xs={3}>
                  <Typography variant="h6">
                    <Box>Send to</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomSelectMulti
                    id="sendToField"
                    itemArr={emailAddress}
                    parentcall={onChangeMultiItem}
                    placeholder="Search by name or email"
                    value={sendToArray}
                  />
                </Grid>
              </Grid>

              <Grid container direction="row" style={{ marginTop: 20 }}>
                <Grid item xs={3}>
                  <Typography variant="h6">
                    <Box>CC to</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomSelectMulti
                    id="ccToField"
                    itemArr={emailAddress}
                    parentcall={onChangeMultiItem}
                    placeholder="Search by name or email"
                    value={ccToArray}
                  />
                  {/* <CustomInput id="cc" variant="outlined" placeholder="Search by name or email" parentcall={setInputState} value={userData.cc} /> */}
                </Grid>
              </Grid>
              {!loading ? (
                <>
                  <Grid container direction="row" style={{ marginTop: 20 }}>
                    <Grid item xs={3}>
                      <Typography variant="h6">
                        <Box>Subject</Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <CustomInput
                        id="subject"
                        variant="outlined"
                        placeholder="Subject"
                        parentcall={setInputState}
                        value={inputValue.subject}
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" style={{ marginTop: 20 }}>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={9}>
                      <FormControl
                        style={{ width: "100%", zIndex: 0 }}
                        variant="outlined"
                      >
                        <SunEditor
                          width="100%"
                          setOptions={{
                            height: 300,
                            plugins: plugins,
                            buttonList: [
                              ["undo", "redo"],
                              ["font", "fontSize", "formatBlock"],
                              ["paragraphStyle", "blockquote"],
                              ["bold", "underline", "italic", "strike"],
                              ["fontColor", "hiliteColor", "textStyle"],
                              "/",
                              ["outdent", "indent"],
                              ["align", "horizontalRule", "list", "lineHeight"],
                              ["table", "link", "image" /** ,'math' */],
                              ["fullScreen", "codeView"],
                              ["preview"],
                              ["save", "template"],
                            ],
                            defaultStyle: "font-family:Arial",
                          }}
                          name="content"
                          onChange={handleChangeTextEditorData}
                          placeholder="Please type here..."
                          autoFocus={true}
                          defaultValue={textEditorValue}
                          setContents={textEditorValue}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Loader />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Box px={3} py={2}>
              <Button
                disableElevation
                style={{ textDecoration: "none" }}
                variant="contained"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                variant="contained"
                onClick={(e) => {
                  handleClose();
                  sendMail(e);
                }}
                color="secondary"
                style={{
                  marginLeft: 10,
                  textTransform: "none",
                }}
              >
                Send email
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}

export default ShortList;
